export const FEATURE_FLAGS = {
  APPLE_MDM_VARIANT: 'block-web-apple-mdm-variant',
  CAREERS_LANDING_PAGE: 'block-web-careers-landing-page',
  AUTOMATED_CARDS: 'block-web-automated-cards',
  BRAND_RESKIN: 'block-web-brand-reskin',
  GLOBAL_SEARCH: 'block-web-global-search'
};

export const KILL_SWITCHES = {
  SEARCH_OPENAI: 'block-web-search-openai'
};
